import React from 'react';
import { get } from 'lodash';
import MenuItem from './MenuItem';
import { BySubscriptionButton } from './styled/MenuStyled';
import { SUBMENU_TYPE } from './MenuSettings/MenuSettings';

const bitrateReg = /\s\(\d+p\)/;

export const getValuesForQualities = (
  qualities,
  currentQuality,
  autoQualityIndex
) =>
  qualities.map((quality) => {
    let name = '';
    let value = '';
    if (quality.bitrate === -1) {
      if (currentQuality === -1 && autoQualityIndex !== -1) {
        name = `${get(
          qualities.filter((q) => q.index === autoQualityIndex),
          [0, 'bitrate'],
          ''
        )}p`;
        value = quality.name;
      } else {
        name = quality.name;
      }
    } else {
      name = `${quality.bitrate}p`;
      value = quality.name.replace(bitrateReg, '');
    }
    return {
      id: quality.bitrate,
      name,
      value,
      isCurrent: quality.bitrate === currentQuality,
      isBlocked: quality.isSubscriptionRestricted,
      type: SUBMENU_TYPE.QUALITIES,
    };
  });

export const getValuesForAudioTracks = (
  audioTracks,
  currentAudioTrack,
  withSubsPhrase
) =>
  audioTracks.map((track) => ({
    name: track.display_name,
    id: track.id,
    isCurrent: track.id === currentAudioTrack,
    type: SUBMENU_TYPE.AUDIO_TRACKS,
    value: track.require_subtitles === true ? withSubsPhrase : undefined,
  }));

export const getValuesForSubtitles = (subtitles, currentSubtitles, offText) =>
  subtitles.map((subs) => ({
    name: subs.index === -1 ? offText : subs.display_name,
    id: subs.index,
    isCurrent: subs.lang_tag === currentSubtitles,
    langTag: subs.lang_tag,
    type: SUBMENU_TYPE.SUBTITLES,
  }));

export const renderSubmenu = (values) =>
  values.map((item) => (
    <MenuItem
      key={item.id}
      name={item.name}
      value={item.value}
      onTap={item.onTap}
      isCurrent={item.isCurrent}
      isBlocked={item.isBlocked}
    />
  ));

export const renderBySubscriptionButton = (
  qualities,
  bySubscriptionPhrase,
  onClick
) => {
  let rendered = null;
  const restricted = qualities.filter((q) => q.isSubscriptionRestricted);
  if (restricted) {
    const bestQuality = restricted.sort((a, b) => a.bitrate - b.bitrate)[0];
    if (bestQuality) {
      const phrase = bySubscriptionPhrase.replace(
        '{bitrate}',
        `${bestQuality.bitrate}p`
      );
      rendered = (
        <BySubscriptionButton
          onClick={onClick}
          isMobile
          text={phrase}
          size="xxl"
          buttonStyle="background"
          theme={{
            main_hover_color: 'green_turquoise',
            main_bg: 'green_turquoise',
          }}
        />
      );
    }
  }
  return rendered;
};
